import { Box, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { Button } from '@/components/Elements/Button/Button';

export function ResetPasswordSuccessPage(props: any) {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  パスワードリセット
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'} color={'#A08B64'}>
                  パスワードが変更されました
                </Typography>
                <Button
                  variant="main"
                  size="lg"
                  className="w-full"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  <div>ログイン画面に戻る</div>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
